import React, { useState } from 'react'
import styles from './MicrositeTagInput.module.css'
import { X } from 'lucide-react'

/**
 * MicrositeTagInput
 * Chip-style multi-value tag input. Used for blog post tags.
 * Type and press Enter or comma to add a tag.
 *
 * Usage:
 *   <MicrositeTagInput
 *     label="Tags"
 *     value={form.tags}
 *     onChange={(next) => updateField('tags', next)}
 *   />
 */
const MicrositeTagInput = ({ label, value = [], onChange, placeholder = 'Type a tag and press Enter' }) => {
    const [draft, setDraft] = useState('')

    const addTag = () => {
        const tag = draft.trim()
        if (!tag || value.includes(tag)) {
            setDraft('')
            return
        }
        onChange?.([...value, tag])
        setDraft('')
    }

    const removeTag = (idx) => {
        onChange?.(value.filter((_, i) => i !== idx))
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault()
            addTag()
        } else if (e.key === 'Backspace' && draft === '' && value.length > 0) {
            removeTag(value.length - 1)
        }
    }

    return (
        <div className={styles.field}>
            {label && <label className={styles.label}>{label}</label>}
            <div className={styles.inputWrap}>
                {value.map((tag, idx) => (
                    <span key={idx} className={styles.chip}>
                        {tag}
                        <button type="button" className={styles.chipRemove} onClick={() => removeTag(idx)}>
                            <X size={11} />
                        </button>
                    </span>
                ))}
                <input
                    type="text"
                    className={styles.input}
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={addTag}
                    placeholder={value.length === 0 ? placeholder : ''}
                />
            </div>
        </div>
    )
}

export default MicrositeTagInput